import React, { useState } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever,
} from "@mui/icons-material";

import { 
  CreatureLimitation,
  Potence,
} from "@dndModels";
import { CHARACTER_LEVELS } from "@dndModels/Constants";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import CreatureLimitInput from '@dndComponents/limitations/CreatureLimitInput';

interface Props {
  obj: Potence;
  onChange: (changed: Potence) => void;
  onDelete: () => void;
  disabled?: boolean;
}

export default function AbilityPotenceEnhanceCreatureInput({ 
  obj,
  onChange,
  onDelete,
  disabled = false
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={2}>
        { !disabled &&
          <Tooltip title={`Delete Potence`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid size={4}>
        <SelectStringBox 
          options={CHARACTER_LEVELS}
          value={`${obj.level}`} 
          name="Level"
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.level = +changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid size={6}>
        <SelectObjectBox 
          name="Gifts to Apply"
          data_type="creature_gift"
          values={ obj.enhance_ids }
          disabled={disabled}
          multiple
          display_format='{obj.use_name}'
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.enhance_ids = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        /> 
      </Grid>
      <Grid size={12}>
        { obj.limits instanceof CreatureLimitation &&
          <CreatureLimitInput
            obj={obj.limits} 
            disabled={disabled}
            onChange={changed => {
              const new_obj = obj;
              new_obj.limits = changed;
              onChange(new_obj);
              setPing(!ping);
            }} 
          />
        }
      </Grid>
    </Grid>
  );
}
